import { gql } from '@apollo/client';
import { TagListData } from '../../../components/App/Content/Admin/TagCategory/tag-category-graphql';
import { GameData } from './game';
import { TRANSLATED_ENTRY_FRAGMENT } from '../translatedEntry/translated-entry-graphql';
import { TAG_FRAGMENT } from '../tags/tag-graphql';
import { SEO_LANG_STATUSES_FRAGMENT, SEO_LANG_STATUSES_ITEM_FRAGMENT } from '../seoStatuses/seo-statuses-graphql';

export const ADMIN_GAME_FRAGMENT = gql`
  fragment AdminGameFragment on Game {
    id
    name {
      ...TranslatedEntryFragment
    }
    slug
    cover
    coverUrl(options: { h: 450 })
    rawGameCoversUrls
    status
    editorStatus
    rawVideo
    description {
      ...TranslatedEntryFragment
    }
    title {
      ...TranslatedEntryFragment
    }
    metaDescription {
      ...TranslatedEntryFragment
    }
    customStructuredData {
      ...TranslatedEntryFragment
    }
    externalLinks {
      wikipedia {
        ...TranslatedEntryFragment
      }
      fandom {
        ...TranslatedEntryFragment
      }
    }
    rawCustomFields
    loaderType
    loaderConfigJson
    rawAlternative
    rawGameframeConfig
    rawControlsJson
    addedOn
    basicLaunchOn
    basicLaunchExpiresOn
    createdOn
    appstoreUrl
    steamstoreUrl
    playstoreUrl
    controls {
      ...TranslatedEntryFragment
    }
    categoryId
    collection
    developer
    user {
      id
      publicProfile {
        displayName
      }
    }
    allowEmbed
    sandbox
    shareEmail
    series
    iosFriendly
    androidFriendly
    isEligibleForMobileHomepage
    chromebookFriendly
    tagIds
    scoreBonus
    temporaryScoreBonus
    temporaryScoreBonusUntil
    mobileScoreBonus
    temporaryMobileScoreBonus
    temporaryMobileScoreBonusUntil
    staffPickedUntil
    staffPickedFrom
    staffPickedWeight
    submissionId(includeFinalized: true)
    forcedFeaturedNew
    forcedFeaturedNewStart
    rawPortalConfig
    preroll
    s3Location
    size
    seoStatuses {
      languageStatuses {
        ...SeoLangStatusesFragment
      }
    }
    isKids
    isOriginal
    forceOriginalFrom
    forceOriginalUntil
    forceOriginalPosition
    lastSignificantUpdatedOn
    rawThumbLabelOverride
    businessTier
    boostLinking
    isRecommendedNextWeek
    isDevHidden
    isHiddenOnHomePage
    isHiddenOnPortal
    seoKeyword
    exclusiveUntil
    exclusiveAutoRenew
    rawFaq
    rawVideoStructuredData
    gameSupportUrl
    isIap
    multiplayerOptions {
      isMultiplayer
      supportsInstantJoin
      hasModeratedChat
      minLobbySize
      maxLobbySize
    }
    rawLeaderboardOptions
    hasLeaderboardSeasons
    leaderboardGuide {
      ...TranslatedEntryFragment
    }
    comments
  }
  ${TRANSLATED_ENTRY_FRAGMENT}
  ${SEO_LANG_STATUSES_FRAGMENT}
  ${SEO_LANG_STATUSES_ITEM_FRAGMENT}
`;

export const ADMIN_GAME_QUERY = gql`
  query AdminGetGame($slug: String!) {
    categories {
      ...TagFragment
    }
    tags {
      ...TagFragment
    }
    gameBySlug(slug: $slug) {
      ...AdminGameFragment
    }
  }
  ${ADMIN_GAME_FRAGMENT}
  ${TAG_FRAGMENT}
`;

export interface AdminGameQuery {
  categories: TagListData[];
  tags: TagListData[];
  gameBySlug: GameData;
}

export interface AdminGameQueryInput {
  slug: string;
}

export function MUTATION_INVALIDATIONS(slug: string) {
  return [{ query: ADMIN_GAME_QUERY, variables: { slug } }];
}
